import React, { useEffect, useState } from 'react';
import ShowAlert from 'src/component/Global/ShowAlert';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { profileStore } from 'src/hooks/profile';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/helper/Helper';
import yellowAlert from "src/assets/images/yellow-alert.png";
import useReduxState from 'src/hooks/useReduxState';

const ExportCompliance = (props) => {
    const { SetStatus, data } = props;
    const initialState = {
        company: "",
        otherCompanyDetail: "",
        exportProduct: "",
        typeOfProduct: "",
        exportCpmpanyName: "",
        exportAddress1: "",
        exportAddress2: "",
        exportCity: "",
        exportCountry: "",
        exportState: "",
        exportZip: "",
        freightForwarder: "",
        freightName: "",
        freightAddress1: "",
        freightAddress2: "",
        freightCity: "",
        freightCountry: "",
        freightState: "",
        freightZip: "",
        condition: ""
    };

    const [__check] = useAxiosIndicatorCheck();
    const [{ countryList }, { get_country_list }, { }] = profileStore();
    const [{ WEB_ORDER_ID, COMPLIANCE_DATA }, { get_compliance_data }, { }] = useCartStore();
    const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const [complianceDetail, setComplianceDetail] = useState(initialState);
    const [complianceValidation, setComplianceValidation] = useState({});
    const [showCompanyField, setShowCompanyField] = useState(false);
    const [showExportFields, setShowExportFields] = useState(false);
    const [showFreightFields, setShowFreightFields] = useState(false);
    const [, setTnc] = useReduxState(false, 'setTnc');

    const [shippingAddressInfo] = useReduxState({}, 'setShippingAddressInfo')

    const loading = __check(["ADD_COMPLIANCE_DATA", "GET_COMPLIANCE_DATA"]).status;

    useEffect(() => {
        async function fetchHere() {
            await get_country_list();
        }
        async function getComplianceData() {
            await get_compliance_data({ formCode: "EC2", languageId: -1 });
        }
        if (countryList?.length <= 0) {
            fetchHere()
        }
        getComplianceData()
    }, [])

    const onDataChange = (field, value) => {
        if (complianceValidation && Object.keys(complianceValidation).length > 0) {
            delete complianceValidation[field];
        }

        if (field === 'company' && value === 'Other') {
            setShowCompanyField(true)
        } else if (field === 'company') {
            setShowCompanyField(false)
            complianceDetail['otherCompanyDetail'] = "";
            delete complianceValidation['otherCompanyDetail'];
        }

        if (field === 'exportProduct' && value === 'Yes') {
            setShowExportFields(true)
        } else if (field === 'exportProduct') {
            setShowExportFields(false)
            complianceDetail['exportCpmpanyName'] = "";
            complianceDetail['exportAddress1'] = "";
            complianceDetail['exportAddress2'] = "";
            complianceDetail['exportCity'] = "";
            complianceDetail['exportCountry'] = "";
            complianceDetail['exportState'] = "";
            complianceDetail['exportZip'] = "";
        }

        if (field === 'freightForwarder' && value === 'Yes') {
            setShowFreightFields(true)
        } else if (field === 'freightForwarder') {
            setShowFreightFields(false)
            complianceDetail['freightName'] = "";
            complianceDetail['freightAddress1'] = "";
            complianceDetail['freightAddress2'] = "";
            complianceDetail['freightCity'] = "";
            complianceDetail['freightCountry'] = "";
            complianceDetail['freightState'] = "";
            complianceDetail['freightZip'] = "";
        }

        setComplianceDetail({ ...complianceDetail, [field]: value });
    };

    const handleSubmit = async () => {
        let isValid = onValidateData();
        if (isValid) {
            const payload = {
                "formId": COMPLIANCE_DATA.formId,
                "versionId": COMPLIANCE_DATA.version,
                "languageId": COMPLIANCE_DATA.languageId,
                "userId": "",
                "orderId": WEB_ORDER_ID.toString(),
                "answers": [
                    {
                        "questionId": 134,
                        "answerTx": complianceDetail.company,
                        "questionType": "RAD",
                        "isDependant": true,
                        "subQuestion": showCompanyField ? {
                            "questionId": 135,
                            "answerTx": complianceDetail.otherCompanyDetail,
                            "questionType": "TXT"
                        } : {}
                    },
                    {
                        "questionId": 136,
                        "answerTx": complianceDetail.typeOfProduct,
                        "questionType": "RAD",
                        "isDependant": false,
                        "subQuestion": {}
                    },
                    {
                        "questionId": 138,
                        "answerTx": complianceDetail.exportProduct ? complianceDetail.exportProduct === "Yes" ? "Y" : "N" : "",
                        "questionType": "RAD",
                        "isDependant": true,
                        "subQuestion": {
                            "questionId": 139,
                            "answerTx": JSON.stringify({
                                "companyNm": showExportFields ? complianceDetail.exportCpmpanyName : shippingAddressInfo?.companyName,
                                "addressTxt01": showExportFields ? complianceDetail.exportAddress1 : shippingAddressInfo?.address?.addressLineOne,
                                "addressTxt02": showExportFields ? complianceDetail.exportAddress2 : shippingAddressInfo?.address?.addressLineTwo,
                                "cityNm": showExportFields ? complianceDetail.exportCity : shippingAddressInfo?.address?.cityName,
                                "countryNm": showExportFields ? complianceDetail.exportCountry : shippingAddressInfo?.address?.countryName,
                                "stateNm": showExportFields ? complianceDetail.exportState : shippingAddressInfo?.address?.stateName,
                                "postalCd": showExportFields ? complianceDetail.exportZip : shippingAddressInfo?.address?.postalCode
                            }),
                            "questionType": "ADD"
                        }
                    },
                    {
                        "questionId": 161,
                        "answerTx": complianceDetail.freightForwarder ? complianceDetail.freightForwarder === "Yes" ? "Y" : "N" : "",
                        "questionType": "RAD",
                        "isDependant": true,
                        "subQuestion": showFreightFields ? {
                            "questionId": 162,
                            "answerTx": JSON.stringify({
                                "companyNm": complianceDetail.freightName,
                                "addressTxt01": complianceDetail.freightAddress1,
                                "addressTxt02": complianceDetail.freightAddress2,
                                "cityNm": complianceDetail.freightCity,
                                "countryNm": complianceDetail.freightCountry,
                                "stateNm": complianceDetail.freightState,
                                "postalCd": complianceDetail.freightZip
                            }),
                            "questionType": "ADD"
                        } : {}
                    },
                    {
                        "questionId": 170,
                        "answerTx": complianceDetail.condition,
                        "questionType": "RAD",
                        "isDependant": false,
                        "subQuestion": {}
                    }
                ]
            }

            await data?.ExportComplienceCallBack(payload);
            remove_system_alert_indicator('ExportCompliance')
            SetStatus(false)
        } else {
            system_alert_indicator({
                name: 'ExportCompliance',
                message: "Please take a moment to correct the highlighted fields. Our Online Support team is ready to help if you need assistance.",
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
        }
    }

    const onValidateData = () => {
        let validationModal = {};

        if (!Helper.valueIsNotNull(complianceDetail.company)) {
            validationModal.company = true;
        }
        if (!Helper.valueIsNotNull(complianceDetail.typeOfProduct)) {
            validationModal.typeOfProduct = true;
        }
        if (!Helper.valueIsNotNull(complianceDetail.typeOfProduct)) {
            validationModal.typeOfProduct = true;
        }
        if (!Helper.valueIsNotNull(complianceDetail.exportProduct)) {
            validationModal.exportProduct = true;
        }
        if (!Helper.valueIsNotNull(complianceDetail.freightForwarder)) {
            validationModal.freightForwarder = true;
        }
        if (!Helper.valueIsNotNull(complianceDetail.condition)) {
            validationModal.condition = true;
        }

        if (Helper.valueIsNotNull(complianceDetail.company) && complianceDetail.company === 'Other' && !Helper.valueIsNotNull(complianceDetail.otherCompanyDetail)) {
            validationModal.otherCompanyDetail = true;
        }
        if (complianceDetail.exportProduct === "Yes" && !Helper.valueIsNotNull(complianceDetail.exportCpmpanyName)) {
            validationModal.exportCpmpanyName = true;
        }
        if ((complianceDetail.exportProduct === "Yes" && !Helper.valueIsNotNull(complianceDetail.exportAddress1))) {
            validationModal.exportAddress1 = true;
        }
        if (complianceDetail.exportProduct === "Yes" && !Helper.valueIsNotNull(complianceDetail.exportState)) {
            validationModal.exportState = true;
        }
        if ((complianceDetail.exportProduct === "Yes" && !Helper.valueIsNotNull(complianceDetail.exportZip))) {
            validationModal.exportZip = true;
        }

        if (complianceDetail.freightForwarder === "Yes" && !Helper.valueIsNotNull(complianceDetail.freightName)) {
            validationModal.freightName = true;
        }
        if ((complianceDetail.freightForwarder === "Yes" && !Helper.valueIsNotNull(complianceDetail.freightAddress1))) {
            validationModal.freightAddress1 = true;
        }
        if (complianceDetail.freightForwarder === "Yes" && !Helper.valueIsNotNull(complianceDetail.freightState)) {
            validationModal.freightState = true;
        }
        if ((complianceDetail.freightForwarder === "Yes" && !Helper.valueIsNotNull(complianceDetail.freightZip))) {
            validationModal.freightZip = true;
        }

        setComplianceValidation(validationModal);
        return Object.keys(validationModal).length === 0;
    }

    const closePopup = () => {
        SetStatus(false)
        remove_system_alert_indicator('ExportCompliance')
        setTnc(false)
    }

    return (
        <>
            <div className="avnet-modal modal-700" id='expcompliancemodal'>
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={closePopup}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h1 className="pcn-modal-heading ps-4 pe-4 font-24">Export Compliance Form</h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body mb-3">
                        <ShowAlert onlyShowMessage={["ExportCompliance"]} />

                        <div className='mb-3 mt-3'>
                            <img className="ms-auto me-1" src={yellowAlert} /><span>Please complete this form in English. If you are unable to do so you may be contacted to verify the information which could delay processing of your order.</span>
                            <p className='mb-3 mt-3'>If order for Avnet to comply with export laws and regulations, the following information is required from all customers. All information provided is confidential and requested of all international customers. Providing complete and accurate information will help ensure that your order is processed and shipped promptly.</p>
                            <p className='mb-2'>Here are the links to the U.S. and Europe export controls for further information.</p>
                            <a className='text-ports' href='http://www.bis.doc.gov' target='_blank'>http://www.bis.doc.gov</a><br />
                            <a className='text-ports' href='http://www.bafa.de' target='_blank'>http://www.bafa.de</a>
                        </div>

                        {__check('GET_COMPLIANCE_DATA').status ? __check('GET_COMPLIANCE_DATA').render :
                            COMPLIANCE_DATA && COMPLIANCE_DATA?.questions?.map((val, i) => {
                                return (
                                    <div key={i}>
                                        {val.description && <p className='mt-3'>{val.description}</p>}
                                        {val.isDependent === false && <p><strong className={val.fieldName in complianceValidation ? 'text-red' : ''}>{val.questionText}</strong></p>}

                                        <ul className="mx-0 px-0">
                                            {val.options.map((options, i) => {
                                                if (options.optionText) {
                                                    return (
                                                        <li key={i}>
                                                            <div className="form-check">
                                                                <input className="form-check-input mt-1" type="radio" name={val.fieldName} id={options.optionText + val.fieldName} value={options.optionText} onChange={({ target: { value } }) => onDataChange(val.fieldName, value)} />
                                                                <label className="form-check-label" htmlFor={options.optionText + val.fieldName}>{options.optionText}</label>
                                                            </div>
                                                        </li>
                                                    )
                                                }
                                            })}
                                        </ul>

                                        {val.fieldName === "other" && showCompanyField &&
                                            <div className='mb-3'>
                                                <p><strong className={complianceValidation.otherCompanyDetail ? 'text-red' : ''}> {val.questionText}</strong></p>
                                                <textarea className="form-control" name='otherCompanyDetail' id="exampleFormControlTextarea1" rows="1" onChange={({ target: { value } }) => onDataChange("otherCompanyDetail", value)}></textarea>
                                            </div>
                                        }
                                        {val.fieldName === "exportProduct" && showExportFields &&
                                            <div className='bs5 row'>
                                                <div className='col-12'>
                                                    <div className="form-group">
                                                        <label className="d-block">Company Name*</label>
                                                        <input type="text" className={`form-control form-control-sm ${complianceValidation.exportCpmpanyName ? "error" : ""}`} id="" placeholder="Company Name" name="exportCpmpanyName" onChange={({ target: { value } }) => onDataChange("exportCpmpanyName", value)} />
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className="form-group">
                                                        <label className="d-block">Address 1*</label>
                                                        <input type="text" className={`form-control form-control-sm ${complianceValidation.exportAddress1 ? "error" : ""}`} id="" placeholder="Address 1" name="exportAddress1" onChange={({ target: { value } }) => onDataChange("exportAddress1", value)} maxLength={35}/>
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className="form-group">
                                                        <label className="d-block">Address 2</label>
                                                        <input type="text"  className={`form-control form-control-sm ${complianceValidation.exportAddress2 ? "error" : ""}`} id="" placeholder="Address 2" name="exportAddress2" onChange={({ target: { value } }) => onDataChange("exportAddress2", value)} maxLength={35}/>
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className="form-group">
                                                        <label className="d-block">City</label>
                                                        <input type="text" className={`form-control form-control-sm ${complianceValidation.exportCity ? "error" : ""}`} id="" placeholder="City" name="exportCity" onChange={({ target: { value } }) => onDataChange("exportCity", value)} />
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className="form-group">
                                                        <div className='selectbox'>
                                                            <select className={`form-control form-control-sm ${complianceValidation.exportCountry ? "error" : ""}`}
                                                                aria-label="Select Country" name="exportCountry"
                                                                onChange={
                                                                    async ({ target: { value } }) => {
                                                                        onDataChange("exportCountry", value);
                                                                        setComplianceDetail({ ...complianceDetail, exportCountry: value })
                                                                    }}
                                                            >
                                                                <option value="">Select Country</option>
                                                                {countryList?.map((v, i) => (
                                                                    <option key={v.countryId} value={v.countryName}>{v.countryName}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className="form-group">
                                                        <label className="d-block">State/Province*</label>
                                                        <input type="text" className={`form-control form-control-sm ${complianceValidation.exportState ? "error" : ""}`} id="" placeholder="State/Province" name="exportState" onChange={({ target: { value } }) => onDataChange("exportState", value)} />
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className="form-group">
                                                        <label className="d-block">Zip/Postal Code*</label>
                                                        <input type="text" className={`form-control form-control-sm ${complianceValidation.exportZip ? "error" : ""}`} id="" placeholder="Zip/Postal Code" name="exportZip" onChange={({ target: { value } }) => onDataChange("exportZip", value)} />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {val.fieldName === "freightForwarder" && showFreightFields &&
                                            <>
                                                <p>Provide the contact information for the ultimate consignee below:< br />
                                                    The ultimate consignee is the recipient of goods delivered by the carrier or freight forwarder.</p>

                                                <div className='bs5 row'>
                                                    <div className='col-12'>
                                                        <div className="form-group">
                                                            <label className="d-block">Ultimate Consignee Name*</label>
                                                            <input type="text" className={`form-control form-control-sm ${complianceValidation.freightName ? "error" : ""}`} id="" placeholder="Ultimate Consignee Name" name="freightName" onChange={({ target: { value } }) => onDataChange("freightName", value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className="form-group">
                                                        <label className="d-block">Address 1*</label>
                                                        <input type="text" className={`form-control form-control-sm ${complianceValidation.freightAddress1 ? "error" : ""}`} id="" placeholder="Address 1" name="freightAddress1" onChange={({ target: { value } }) => onDataChange("freightAddress1", value)} maxLength={35} />
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className="form-group">
                                                        <label className="d-block">Address 2</label>
                                                        <input type="text" className={`form-control form-control-sm ${complianceValidation.freightAddress2 ? "error" : ""}`} id="" placeholder="Address 2" name="freightAddress2" onChange={({ target: { value } }) => onDataChange("freightAddress2", value)} maxLength={35} />
                                                    </div>
                                                    <div className='col-12'>
                                                        <div className="form-group">
                                                            <label className="d-block">City</label>
                                                            <input type="text" className={`form-control form-control-sm ${complianceValidation.freightCity ? "error" : ""}`} id="" placeholder="City" name="freightCity" onChange={({ target: { value } }) => onDataChange("freightCity", value)} />
                                                        </div>
                                                    </div>
                                                    <div className='col-12'>
                                                        <div className="form-group">
                                                            <div className='selectbox'>
                                                                <select className={`form-control form-control-sm ${complianceValidation.freightCountry ? "error" : ""}`}
                                                                    aria-label="Select Country" name="freightCountry"
                                                                    onChange={
                                                                        async ({ target: { value } }) => {
                                                                            onDataChange("freightCountry", value);
                                                                            setComplianceDetail({ ...complianceDetail, freightCountry: value })
                                                                        }}
                                                                >
                                                                    <option selected>Select Country</option>
                                                                    {countryList?.map((v, i) => (
                                                                        <option key={v.countryId} value={v.countryName}>{v.countryName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-6'>
                                                        <div className="form-group">
                                                            <label className="d-block">State/Province*</label>
                                                            <input type="text" className={`form-control form-control-sm ${complianceValidation.freightState ? "error" : ""}`} id="" placeholder="State/Province" name="freightState" onChange={({ target: { value } }) => onDataChange("freightState", value)} />
                                                        </div>
                                                    </div>
                                                    <div className='col-6'>
                                                        <div className="form-group">
                                                            <label className="d-block">Zip/Postal Code*</label>
                                                            <input type="text" className={`form-control form-control-sm ${complianceValidation.freightZip ? "error" : ""}`} id="" placeholder="Zip/Postal Code" name="freightZip" onChange={({ target: { value } }) => onDataChange("freightZip", value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>}
                                    </div>
                                )
                            })
                        }

                        <p>Thank you for your attention to this matter. We look forward to doing future business with you.</p>

                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary minw140"
                            disabled={loading}
                            onClick={closePopup}
                        >
                            Cancel
                        </button>
                        <button type="button" disabled={loading} className="bs5 btn btn-primary minw140" onClick={handleSubmit}>
                            {__check("ADD_COMPLIANCE_DATA").status ?
                                <i className="fa fa-spinner fa-spin" /> :
                                "Submit"
                            }
                        </button>
                    </div>
                </div>
            </div>


        </>
    );
}

export default ExportCompliance;